import logo from './logo.svg';
import './App.css';
import Login from './components/LoginComponent';
import HomeScreen from './components/HomeComponent';
import CollectionReport from './components/CollectionReport';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Users from './components/Users';
import CollectionCenter from './components/CollectionCenter';
import BillDetails from './components/BillDetails';
import AddFarmer from './components/AddFarmer';
import Features from './components/Features';
import RateChart from './components/RateChart';
import EditUser from './components/EditUser';
import Ledger from './components/Ledger';
import Dues from './components/Dues';
import AddRateChart from './components/AddRateChart';
import AddFarmerDetails from './components/AddFarmerDetails';
import Navbar from './components/Navbar';
import EditFarmerDetails from './components/EditFarmerDetails';
import Payments from './components/Payments';
import AddPayments from './components/AddPayments';
import Bills from './components/Bills';
import GenerateBill from './components/GenerateBill';
import CollectMilk from './components/CollectMilk';
import AddCollection from './components/AddCollection';
import EditPermissions from './components/EditPermissions';
import MilkReport from './components/MilkReport';
import EditPayment from './components/EditPayment';
import EditCollection from './components/EditCollection';
import EditRateChart from './components/EditRateChart';
import GenerateBillPdf from './components/GenerateBillPdf';
import AddUser from './components/AddUser';


function App() {
  const token = localStorage.getItem("dairy-token");
  return (

    <BrowserRouter>
    <AuthProvider>
    {token && <Navbar />} 
      <Routes>
        <Route path='/' element={<HomeScreen/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/users' element={<Users />} />
        <Route path='/users/AddUser' element={<AddUser />} />
        <Route path='/CollectionCenter' element={<CollectionCenter />} />
        <Route path='/billdetails' element={<BillDetails />} />
        <Route path='/CollectionReport' element={<CollectionReport />} />
        <Route path='/CollectionCenter/Features/MilkReport' element={<MilkReport />} />
        <Route path='/CollectionCenter/Features/AddFarmer' element={<AddFarmer />} />
        <Route path='/CollectionCenter/Features/AddFarmer/AddFarmerDetails' element={<AddFarmerDetails />} />
        <Route path='/CollectionCenter/Features' element={<Features />} />
        <Route path='/CollectionCenter/Features/Payments/AddPayments' element={<AddPayments />} />
        <Route path='/CollectionCenter/Features/Payments/EditPayment' element={<EditPayment />} />
        <Route path='/CollectionCenter/Features/Payments' element={<Payments />} />
        <Route path='/CollectionCenter/Features/RateChart' element={<RateChart />} />
        <Route path='/Users/EditUser' element={<EditUser />} />
        <Route path='/Users/EditUser/EditPermissions' element={<EditPermissions />} />
        <Route path='/CollectionCenter/Features/ledger' element={<Ledger />} />
        <Route path='/CollectionCenter/Features/dues' element={<Dues />} />
        <Route path='/CollectionCenter/Features/Bills' element={<GenerateBill />} />
        <Route path='/CollectionCenter/Features/Bills/pdf' element={<GenerateBillPdf />} />
        <Route path='/CollectionCenter/Features/CollectMilk' element={<CollectMilk />} />
        <Route path='/CollectionCenter/Features/CollectMilk/AddCollection' element={<AddCollection />} />
        <Route path='/CollectionCenter/Features/CollectMilk/EditCollection' element={<EditCollection />} />
        <Route path='/CollectionCenter/Features/AddFarmer/EditFarmerDetails' element={<EditFarmerDetails />} />
        <Route path='/CollectionCenter/Features/RateChart/AddRateChart' element={<AddRateChart />} />
        <Route path='/CollectionCenter/Features/RateChart/EditRateChart' element={<EditRateChart />} />

        
      </Routes>
    </AuthProvider>
    </BrowserRouter>

  );
}

export default App;
